// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fMR8","questions":"styles_questions__1qENg","footer":"styles_footer__14MFL"};